import React from 'react'
import { VuiRowIconList } from '@topkamera/viso-ui'
import './NotificationListPeriod.scss'

const NotificationListPeriod = ({
  items = [], color = 'accent0', onClick, title
}) => {

  const mapTextFormatter = (data) => {
    const { actor = null } = data
    const actorName = actor ? <span className='vui-medium'>{actor.firstName} {actor.lastName}</span> : null
    return <span>{actorName} {data?.message}</span>
  }

  return (items.length > 0 &&
    <div className='vui-flex vui-flex-column vui-gap-5 viso-notification-list-period'>
      <div className='vui-text-label vui-body-xs'>{title}</div>
      <div className='vui-pt-5 vui-pb-20 viso-notification-list-period__items'>
        <VuiRowIconList
          color={color}
          indicator={{
            borderStyle: 'light',
            color: color
          }}
          textFormatter={(item) => mapTextFormatter(item.itemData)}
          items={items}
          onClick={(item) => onClick(item.itemData._id)}
        />
      </div>
    </div>
  )
}

export default NotificationListPeriod